import React, { useState } from 'react'
import {ReactComponent as ArrowDown} from '@svgs/arrow-down.svg'
import { onEnterKeyPress } from '@src/utils/general';

const ItemsPerPageSelector = ({itemsPerPage, setItemsPerPage, sortedProducts}) => {
  const [isOpen, setIsOpen] = useState(false)
  const itemOptions = [24, 18, 12, 9].filter(num => num <= sortedProducts?.length || num === itemsPerPage);

  return (
    <div className='py-0 md:py-5 max-md:mb-5 max-md:h-full flex flex-col w-full items-stretch md:items-end relative max-md:border-1 max-md:border-solid max-md:border-gray max-md:rounded-xl max-md:select-none' >
      <div className='flex justify-between items-center max-md:p-5 cursor-pointer' onClick={() => setIsOpen((prevState) => !prevState)} onKeyDown={(e) => onEnterKeyPress(e, () => setIsOpen((prevState) => !prevState))} role='button' aria-label={`Items per Page Selector. Currently showing ${itemsPerPage} products`} tabIndex={0} aria-expanded={isOpen}>
        <p className='pr-1'><b>Show: </b><span className='text-safety-green'>{itemsPerPage} products</span></p>
        <ArrowDown className={`fill-darker-gray md:fill-black`} />
      </div>
      
      <div className={`${isOpen ? 'max-h-64 visible' : 'max-h-0 invisible'} max-md:w-full flex flex-col bg-white border-1 border-solid border-gray rounded-xl z-10 transition-all duration-300 overflow-hidden absolute right-0 top-full translate-y-2.5 md:-translate-y-2.5`}>
        {itemOptions.map(option => (
          <div
            className={`cursor-pointer text-safety-green border-t-1 first:border-t-0 border-solid border-gray p-2.5 hover:bg-light-gray transition-all duration-300 max-md:w-full max-md:text-center ${itemsPerPage === option ? 'bg-light-gray' : 'bg-white'}`}
            key={`items-per-page-${option}`}
            onClick={() => setItemsPerPage(option)}
            onKeyDown={(e) => onEnterKeyPress(e, () => setItemsPerPage(option))}
            tabIndex={isOpen ? 0 : -1}
            aria-label={`${option} products ${itemsPerPage === option ? ', selected' : ''}`}
          >
            {option} products
          </div>
        ))}
      </div>
    </div>
  )
}

export default ItemsPerPageSelector